import React, { useEffect, useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import List from '@material-ui/core/List';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import Checkbox from '@material-ui/core/Checkbox';
import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
import clienteAxios from 'service/axios';
import AuthContext from "context/autentication/authContext";
import MuiAlert from '@material-ui/lab/Alert';
import { Role } from "types/roles";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}


const useStyles = makeStyles((theme) => ({
  root: {
    margin: 'auto',
    width: '100%',
    /* height: '400px' */
  },
  cardHeader: {
    padding: theme.spacing(1, 2),
  },
  list: {
    width: 300,
    height: 230,
    backgroundColor: theme.palette.background.paper,
    overflow: 'auto',
  },
  button: {
    margin: theme.spacing(0.5, 0),
  },
}));

function not(a, b) {
  return a.filter((value) => b.indexOf(value) === -1);
}

function intersection(a, b) {
  return a.filter((value) => b.indexOf(value) !== -1);
}

function union(a, b) {
  return [...a, ...not(b, a)];
}

export default function CompartirDispositivo(props) {
  //console.log(props.data)
  const classes = useStyles();
  const [callback, setCallback] = React.useState(0);
  const [checked, setChecked] = React.useState([]);
  const authContext = useContext(AuthContext);
  const { autenticado, rol, usuario, cerrarSesion } = authContext;
  /////////////////mensaje error ///////////
  const [state, setState] = React.useState({
    vertical: 'top',
    horizontal: 'center',
  });

  const [open, setOpen] = React.useState(true);

  const handleClick = () => {
    setOpen(true);
  };

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  }; 

  /////////////////////////////////////////////////////////
  //      obtengo dispositivos disponibles para compartir ///// 
  const obtenerDisponibles = async (clienteId, disponibles) => {
    let resultado = [];
    let temp = []
    if (clienteId) {
      temp = await clienteAxios.get(`/usuarios/cliente/${clienteId}`);
      if (temp.data) {
        resultado = temp.data.usuarios
      }
    }
    const leftFiltrados = filterData(resultado)
    const menosDerechos = eliminarDuplicados(leftFiltrados, disponibles)
    setLeft(menosDerechos)
    return menosDerechos

  }
  const filterData = (array) => {
    let result = []
    let aux = { "_id": "", "nombre": "" }
    array.map((a) => {
      if (a.clienteRol[0].rol === Role.Operador) {
        result.push({ "_id": a._id, "nombre": a.nombre })
      }
    })
    return result
  }

  ///////////////////////////////////////////////////////
  ///////// obtengo los usuarios ya compartidos /////////

  const obtenerCompartidos = async (dispositivoId) => {
    let resultado = [];
    let temp = []
    if (dispositivoId) {
      temp = await clienteAxios.get(`/usuarioDispositivo/?dispositivo=${dispositivoId}`);
      if (temp.data) {
        resultado = temp.data.usuariosDispositivos
      }
    }
    const filtrados = filterCompartidos(resultado)
    setRight(filtrados)
    return filtrados
  }
  const filterCompartidos = (array) => {
    let result = []
    //console.log(props.data.cliente)
    let aux = { "_id": "", "nombre": "" }
    array.map((a) => {
      if (a.usuario.clienteRol[0].rol === Role.Operador) {
        if (usuario._id !== a.usuario._id) {
          result.push({ "_id": a.usuario._id, "nombre": a.usuario.nombre })
        }
      }
    })
    return result
  }
  const eliminarDuplicados = (left, right) => {
    let le = left;
    let ri = right;
    //console.log("l =>", le)
    //console.log("r =>",ri)
    ri.map((us) => {
      le = le.filter((x) => x._id !== us._id)
    })
    le = le.filter((x) => x._id !== usuario._id)
    return le
  }
  const [left, setLeft] = React.useState([]);
  const [right, setRight] = React.useState([]);
  /////////////////////////////////////////////////////////////////
  //////////////////////////use effect ////////////////////////////
  /////////////////////////////////////////////////////////////////
  useEffect(() => {

    obtenerCompartidos(props.data._id)
      .then(value => obtenerDisponibles(props.data.cliente._id, value))

    // eslint-disable-next-line
  }, []);




  const leftChecked = intersection(checked, left);
  const rightChecked = intersection(checked, right);
  //console.log(props.data)


  const handleToggle = (value) => () => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setChecked(newChecked);
  };

  const numberOfChecked = (items) => intersection(checked, items).length;

  const handleToggleAll = (items) => () => {
    if (numberOfChecked(items) === items.length) {
      setChecked(not(checked, items));
    } else {
      setChecked(union(checked, items));
    }
  };

  const handleCheckedRight = () => {
    setCallback(0)
    setRight(right.concat(leftChecked));
    setLeft(not(left, leftChecked));
    setChecked(not(checked, leftChecked));
  };

  const handleCheckedLeft = () => {
    setCallback(0)
    setLeft(left.concat(rightChecked));
    setRight(not(right, rightChecked));
    setChecked(not(checked, rightChecked));
  };

  const customList = (title, items) => (
    <Card>
      <CardHeader
        className={classes.cardHeader}
        avatar={
          <Checkbox
            onClick={handleToggleAll(items)}
            checked={numberOfChecked(items) === items.length && items.length !== 0}
            indeterminate={numberOfChecked(items) !== items.length && numberOfChecked(items) !== 0}
            disabled={items.length === 0}
            inputProps={{ 'aria-label': 'all items selected' }}
          />
        }
        title={title}
        subheader={`${numberOfChecked(items)}/${items.length} elegidos`}
      />
      <Divider />
      <List className={classes.list} dense component="div" role="list">
        {items.map((value) => {
          const labelId = `transfer-list-all-item-${value.nombre}-label`;

          return (
            <ListItem key={value} role="listitem" button onClick={handleToggle(value)}>
              <ListItemIcon>
                <Checkbox
                  checked={checked.indexOf(value) !== -1}
                  tabIndex={-1}
                  disableRipple
                  inputProps={{ 'aria-labelledby': labelId }}
                />
              </ListItemIcon>
              <ListItemText id={labelId} primary={` ${value.nombre}`} />
            </ListItem>
          );
        })}
        <ListItem />
      </List>
    </Card>
  );

  const filtrarListaGuardar = (usuarios) => {
    let result = []
    usuarios.map((a) => {
      result.push({ "_id": a._id })
    })
    return result
  }
  const guardar = (x) => {
    const data = { "dispositivo": props.data._id }
    const listaFiltrada = filtrarListaGuardar(x)

    data.usuarios = listaFiltrada
    updateDispositivo(data).then(value => setCallback(value.status))
  }

  const updateDispositivo = async (x) => {
    const resultado = await clienteAxios.post(`/dispositivoUsuarios`, x)
    return resultado
  }

  return (
    <>
      <Grid container spacing={1} direction="row" justify="center" alignItems="center" className={classes.root}>
        <Grid item xs={12} md={5} lg={5}>{customList('Sin compartir', left)}</Grid>
        <Grid item xs={12} md={2} lg={2}>
          <Grid container direction="column" alignItems="center">
            <Button
              variant="outlined"
              size="small"
              className={classes.button}
              onClick={handleCheckedRight}
              disabled={leftChecked.length === 0}
              aria-label="move selected right"
            >
              &gt;
          </Button>
            <Button
              variant="outlined"
              size="small"
              className={classes.button}
              onClick={handleCheckedLeft}
              disabled={rightChecked.length === 0}
              aria-label="move selected left"
            >
              &lt;
          </Button>
          </Grid>
        </Grid>
        <Grid item xs={12} md={5} lg={5}>{customList('Compartiendo', right)}</Grid>
        <Grid item>
          <div style={{ width: "120px", height: "30px" }}>
            <Button variant="contained" style={{color:"#FCFCFC",backgroundColor: "#0B3845" }} onClick={() => { guardar(right) }}>
              Confirmar
          </Button>
          </div>
          {/* <div style={{ width: "100px", height: "20px" }}>
          {callback === 200  ?
              <>   
              <Snackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }} open={open} onClose={handleClose} autoHideDuration={6000} key={vertical + horizontal}>      
                <Alert variant="filled" severity="success">
                  {"Operacion exitosa"}
                </Alert>
            </Snackbar> 
            </>
          : 
          ( callback === 400 ?
            <>         
              <Snackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }} open={open} onClose={handleClose} autoHideDuration={6000} key={vertical + horizontal}> 
                <Alert variant="filled" severity="error">
                  {"Error al realizar la operacion"}
                </Alert>
              </Snackbar> 
            </>   
            : null)
          }  
          </div> */}
        </Grid>
      </Grid>
    </>
  );
}
